module.exports = __webpack_public_path__ + "static/media/channel-background.3fb5717c.png";